import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AlgoliaApp } from './Algolia.App';
import { createRoot } from 'react-dom/client';
import { ErrorElement } from '../Components/react/ErrorElement';
import { templateConfigsLoader } from './loader/templateConfigs.loader';
const container = document.querySelector('.alg-app');
if (container !== null) {
    const appRouter = createBrowserRouter([
        {
            path: '/collections/:handle',
            element: React.createElement(AlgoliaApp, { pagePath: 'collections' }),
            loader: templateConfigsLoader,
            errorElement: React.createElement(ErrorElement, null),
            children: [
                { path: ':medium' }
            ]
        },
        {
            path: '/pages/topic',
            element: React.createElement(AlgoliaApp, { pagePath: 'search' }),
            loader: templateConfigsLoader,
            errorElement: React.createElement(ErrorElement, null),
            children: [
                { path: ':medium' }
            ]
        },
        {
            path: '/pages/tags',
            element: React.createElement(AlgoliaApp, { pagePath: 'search' }),
            loader: templateConfigsLoader,
            errorElement: React.createElement(ErrorElement, null),
            children: [
                { path: ':medium' }
            ]
        },
        {
            path: '/pages/query',
            element: React.createElement(AlgoliaApp, { pagePath: 'search' }),
            loader: templateConfigsLoader,
            errorElement: React.createElement(ErrorElement, null),
            children: [
                { path: ':medium' }
            ]
        },
        {
            path: '/search',
            element: React.createElement(AlgoliaApp, { pagePath: 'search' }),
            loader: templateConfigsLoader,
            errorElement: React.createElement(ErrorElement, null)
        },
        {
            path: '*',
            element: React.createElement(ErrorElement, null)
        }
    ]);
    const root = createRoot(container);
    root.render(React.createElement(RouterProvider, { router: appRouter }));
}
